import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { Responsive } from 'semantic-ui-react';

import arrowDown from '../../../assets/arrowdown.svg';
import * as styles from './ArticleMenu.less';

const black = { color: '#000' };
const purple = { color: '#4916A9' };

const ArticleMenuItems = ({ items }) => {
  return items.map((item, key) => (
    <div key={key}>
      {key == 0 && <div className={styles.menuDivider} />}
      {item.title && (
        <div className={styles.menuItem} style={purple}>
          <a href={`#${item.link}`}>{item.title}</a>
        </div>
      )}
    </div>
  ));
};

ArticleMenuItems.propTypes = {
  items: PropTypes.array,
};

const ArticleMenu = ({ items }) => {
  const [open, toggleOpen] = useState(false);

  return (
    <div className={styles.menuWrapper}>
      <div className={styles.menuList}>
        <div
          className={styles.menuItem}
          style={black}
          onClick={() => toggleOpen(!open)}
        >
          In this article
          <Responsive maxWidth={Responsive.onlyTablet.minWidth}>
            <img
              src={arrowDown}
              className={styles.arrowDown}
              style={{
                transition: 'all .5s',
              }}
            />
          </Responsive>
        </div>

        <Responsive minWidth={Responsive.onlyTablet.minWidth}>
          <ArticleMenuItems items={items} />
        </Responsive>

        {open && (
          <Responsive maxWidth={Responsive.onlyTablet.minWidth}>
            <ArticleMenuItems items={items} />
          </Responsive>
        )}
      </div>
    </div>
  );
};

ArticleMenu.propTypes = {
  items: PropTypes.array,
};

export default ArticleMenu;



// WEBPACK FOOTER //
// ./src/views/components/ArticleMenu/ArticleMenu.js